[
  { "label": "Apparel", "value": "apparel" },
  { "label": "Automotive", "value": "automotive" },
  { "label": "Baby", "value": "baby" },
  { "label": "Beauty", "value": "beauty" },
  { "label": "BISS", "value": "biss" },
  { "label": "Books", "value": "books" },
  { "label": "Electronics - PC", "value": "electronics_pc" },
  { "label": "Electronics - Device", "value": "electronics_device" },
  { "label": "Electronics - Accessories", "value": "electronics_accessories" },
  { "label": "Grocery", "value": "grocery" },
  { "label": "Gift Cards", "value": "gift_cards" },
  { "label": "Health", "value": "health" },
  { "label": "Home Improvement", "value": "home_improvement" },
  { "label": "Home - Small Appliances", "value": "home_small_appliances" },
  { "label": "Home and Kitchen - Other", "value": "home_kitchen_other" },
  { "label": "Jewellery", "value": "jewellery" },
  { "label": "Luggage", "value": "luggage" },
  { "label": "Music", "value": "music" },
  { "label": "Movies", "value": "movies" },
  { "label": "Mobile Phones", "value": "mobile_phones" },
  { "label": "Mobile Phone Accessories", "value": "mobile_phone_accessories" },
  { "label": "Office Products", "value": "office_products" },
  { "label": "Personal Appliances", "value": "personal_appliances" },
  { "label": "Pet Supplies", "value": "pet_supplies" },
  { "label": "Shoes & Handbags", "value": "shoes_handbags" },
  { "label": "Software", "value": "software" },
  { "label": "Sporting Goods", "value": "sporting_goods" },
  { "label": "Toys", "value": "toys" },
  { "label": "Video Games - Console", "value": "video_games_console" },
  { "label": "Video Games - Games", "value": "video_games_games" },
  { "label": "Watches", "value": "watches" }
]
